export const getPeopleWord = (lang: string, people: number) => {
    if(lang === "en"){
        if(people === 1){
            return "person";
        }else{
            return "people";
        }
    }else{
        if(people === 1){
            return "osobu";
        }else if(people > 1 && people < 5){
            return "osoby"
        }else{
            return "osob";
        }
    }
}
